import Timeline from '../../../components/Timeline';
import { Component } from 'react';
import { module1Keys } from './keys';
import { colors } from '../../../lib/colors';
import { getRandomColor } from '../../../lib/colors';
import { withTranslation } from 'react-i18next';

class PositionModule1 extends Component {
    constructor() {
        super();

        this.addActive = this.addActive.bind(this);

        this.state = {
            selectedItem: {},
            type: 'all',
            labels: [],
            tags: [],
        };
    }

    componentDidMount() {
        const tags = this.props.data?.map((item) => ({
            id: item.searchappearance,
            label: item.searchappearance,
        }));
        tags.unshift({ label: 'All', id: 'all' });

        this.setState({
            type: 'all',
            selectedItem: this.props.data,
            tags,
        });
    }

    onChangeTags(tag_id) {
        this.setState({
            type: tag_id,
            selectedItem: this.props.data?.find((x) => x.searchappearance === tag_id),
        });
    }

    addActive(id) {
        if (this.state.type.includes('all')) {
            if (id === 'all') return true;
            return false;
        }

        return this.state.type.includes(id);
    }

    render() {
        const { t } = this.props;
        let chartData = {};
        if (this.state.type === 'all') {
            chartData = {
                labels: this.props.data?.[0]?.dateL.map((item) => item.value),
                datasets: this.props.data?.map((item, i) => {
                    const color = colors[i] || getRandomColor();
                    return {
                        label: item.searchappearance,
                        type: 'line',
                        data: item.clicksL,
                        borderColor: color,
                        backgroundColor: color,
                        borderRadius: 4,
                        tension: 0.4,
                    };
                }),
            };
        } else {
            chartData = {
                labels: this.state.selectedItem?.dateL.map((item) => item.value),
                datasets: module1Keys(t).map((item, i) => ({
                    label: item.label,
                    type: item.type || 'line',
                    data: this.state.selectedItem[item.key],
                    borderColor: colors[i],
                    backgroundColor: colors[i],
                    yAxisID: item.yAxisID || 'y',
                    hidden: item.hidden || false,
                    borderRadius: 4,
                    tension: 0.4,
                })),
            };
        }

        const extraBox = (
            <div className="tags-container">
                {this.state.tags?.map((tag) => (
                    <span
                        className={`tab-item ${tag.id === this.state.type && 'active-tag'}`}
                        key={tag.id}
                        onClick={() => this.onChangeTags(tag.id)}
                    >
                        {tag.label}
                    </span>
                ))}
            </div>
        );

        return (
            <>
                <Timeline
                    chartSize="lg"
                    extraBox={extraBox}
                    metricType="primary"
                    data={chartData?.labels?.map((x) => ({ date: x }))}
                    error={this.props.error}
                    keys={module1Keys(t)}
                    header={t('search.search_appearance.header')}
                    parent_id={this.props.parent_id}
                    content_id={this.props.content_id}
                    forceRun={this.props.forceRun}
                    chartData={chartData}
                    hasRightAxis={this.state.type !== 'all'}
                    dontShowMetrics
                    leftAxisLabel={
                        this.state.type === 'all'
                            ? t('global.clicks')
                            : t('search.search_appearance.leftAxisLabel')
                    }
                    xAxisTitle="Date"
                    showGoogleFeeds
                    rightAxisLabel={t('global.ctr_per')}
                    rightSecondAxisLabel={t('global.positions')}
                    hasSecondRightAxis
                    secondRightAxisReversed
                />
            </>
        );
    }
}

export default withTranslation()(PositionModule1);
